import { isEqual } from 'lodash'

import { ParameterizationType } from '@/types/variable'

// For human readability, we use stateNames here instead of stateIds
const isCPTChanged = (
  oldVariable: {
    inboundArrows: { stateNames: string[]; parentId: string }[]
    stateNames: string[]
    parameterizationType: ParameterizationType
    probabilities: number[]
  },
  newVariable: {
    inboundArrows: { stateNames: string[]; parentId: string }[]
    stateNames: string[]
    parameterizationType: ParameterizationType
    probabilities: number[]
  },
) => {
  if (oldVariable.parameterizationType !== newVariable.parameterizationType) {
    return true
  }
  if (oldVariable.probabilities.length !== newVariable.probabilities.length) {
    return true
  }
  return !isEqual(oldVariable.probabilities, newVariable.probabilities)
}

export default isCPTChanged
